function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#891818;}.b{fill:#fff;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M60,46.535A13.466,13.466,0,0,1,46.535,60H13.465A13.473,13.473,0,0,1,0,46.535V13.465A13.473,13.473,0,0,1,13.465,0h33.07A13.473,13.473,0,0,1,60,13.465Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M197.049,123.451c1-.035,2-.012,3.007-.012h.408v-5.263c-.536-.059-1.1-.13-1.655-.153-1.026-.047-2.051-.094-3.088-.071a7.546,7.546,0,0,0-4.347,1.354,6.551,6.551,0,0,0-2.61,4.392,16.28,16.28,0,0,0-.186,2.261c-.023,1.177,0,2.355,0,3.544v.447H183.6v5.875h4.953V150.59H194.6V135.837h4.941c.256-1.954.5-3.885.758-5.9h-1.107c-1.41.012-4.627,0-4.627,0s.012-2.908.047-4.18C194.66,124.028,195.685,123.5,197.049,123.451Z",
  transform: "translate(-162.037 -104.201)"
});

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.33de523d.svg";
export { ForwardRef as ReactComponent };